<template>
  <div>
    <!--Breadcrumb button-->
    <breadcrumb-button>
      <template #beforeDropdown>
        <b-button
            variant="success"
            class="btn-icon position-relative"
            v-b-tooltip
            v-bind:title="$t('operations.add')"
            @click="onTitanSelected(null)"
        >
          <i class="fa-solid fa-bullhorn"></i>
          <i
              class="fa-solid fa-plus position-absolute"
              style="font-size: 0.6em; top: 14px; right: 1px;"
          ></i>
        </b-button>
      </template>
      <template #items>
        <b-dropdown-item @click="openColumnsModal">
          <feather-icon
              icon="CheckSquareIcon"
              size="16"
          />
          <span class="align-middle ml-50">{{ $t('columns.self') }}</span>
        </b-dropdown-item>
      </template>
    </breadcrumb-button>

    <!--Filters-->
    <filter-card v-model="filter" v-bind:fields="filterFields" search/>

    <!-- Tabs with tables -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>{{ $t("menu.titans") }}</h5>
      </b-card-header>
      <b-card-body>
            <titans-table
                ref="titanTable1"
                v-bind:filters="filter"
                v-bind:columns="columns"
                :has-selection="false"
                @selected="onTitanSelected"
                :lazy="true"
            />

      </b-card-body>
    </b-card>

    <!--Modal-->
    <columns-modal ref="columns-modal" column-key="titans" v-model="columns"
                   v-bind:columns-names="columnsNames" />
    <titan-modal ref="titan-modal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import BreadcrumbButton from '@/components/widget/breadcrumbButton'
import TitanSearchRequest from '@/model/campaign/TitanSearchRequest'
import ColumnsModal from '@/components/modal/columnsModal'
import Titan from '@/model/campaign/Titan'
import mixinPermissions from '@/components/mixin/mixinPermissions'
import mixinBase from '@/components/mixin/mixinBase'
import TitanModal from '@/components/modal/titanModal'
import FilterCard from '@/components/widget/FilterCard'
import TitanFilterFields from '@/model/filter/TitanFilterFields'
import TitansTable from '@/components/tables/TitanTable'

export default {
  name: 'TitansView',
  components: {
    TitansTable,
    FilterCard,
    TitanModal,
    ColumnsModal,
    BreadcrumbButton
  },
  mixins: [mixinBase, mixinPermissions],
  data() {
    return {
      columnsNames: Object.keys(Titan()),
      filter: TitanSearchRequest(),
      filterLoaded: false,
      columns: [],
      filterFields: null,
    }
  },
  async created() {
    await this.refreshData()
    this.filterFields = TitanFilterFields()
  },
  computed: {
    ...mapGetters('data', ['allOrganizations']),
  },
  methods: {
    ...mapActions('titan', ['refreshData']),
    openColumnsModal() {
      this.$refs['columns-modal'].showModal()
    },
    onTitanSelected(selectedId) {
      this.$refs['titan-modal'].showModal(selectedId)
    },
  }
}
</script>
